module.exports = __webpack_public_path__ + "img/5.3b52818a.png";